import { useSelector, useDispatch } from "react-redux";
import { getUserState } from "../../Redux/Slices/User";
import { useEffect } from "react";
import { authThunk } from "../../Redux/Slices/User/thunks";
import { useNavigate } from "react-router-dom";

export default await function ProtectedRoute({children}){
    const dispatch = useDispatch()
    const user = useSelector(getUserState)
    const navigate = useNavigate()
    
    async function auth () {
        try{
            const res = await dispatch(authThunk())
            console.log(res);
            
            if(res.payload.detail) navigate('/login')
        } catch {
            navigate('/login')
            window.location.reload()
        }
    }
    
    useEffect(() => {   
        auth()
        // eslint-disable-next-line
    }, [navigate])
    

    return user ? children : null
}